<template>
    <button
        class="group gap-x-2 rounded-md p-1 text-sm ease-out flex transition-all duration-100"
        @click.stop="copyEventTypePreviewToClipboard"
        :class="{
            'text-z-primary-600 hover:bg-z-primary-50': eventType.enabled_at,
            'text-iron-500': !eventType.enabled_at,
        }"
        :disabled="!eventType.enabled_at"
        @mouseover="iconsShown = true"
        @mouseleave="iconsShown = false"
    >
        <span class="sm:max-w-[320px] md:max-w-full max-w-[250px] truncate">
            {{ eventType.public_url }}
        </span>

        <Transition v-if="eventType.enabled_at">
            <div v-if="iconsShown">
                <Transition mode="out-in">
                    <Link
                        v-if="!copied"
                        :class="{
                            'text-z-primary-500': eventType.enabled_at,
                            'text-iron-400': !eventType.enabled_at,
                        }"
                        :size="20"
                        :stroke-width="1.75"
                        absolute-stroke-width
                    />
                    <ClipboardCheck
                        v-else
                        :class="{
                            'text-z-primary-500': eventType.enabled_at,
                            'text-iron-500': !eventType.enabled_at,
                        }"
                        :size="20"
                        :stroke-width="1.75"
                        absolute-stroke-width
                    />
                </Transition>
            </div>
        </Transition>
    </button>
</template>

<script setup lang="ts">
import { useClipboard } from "@vueuse/core";
import { Link, ClipboardCheck } from "lucide-vue-next";
import { ref } from "vue";

const { copy, copied } = useClipboard();

const iconsShown = ref(false);

const props = defineProps<{
    eventType: any;
}>();

function copyEventTypePreviewToClipboard() {
    copy(props.eventType.public_url);
}
</script>

<style scoped></style>
